var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeagueSyncP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26411_8792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7383 1.94531L13.2383 4.44531L10.7383 6.94531",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.23828 7.44531V5.44531C2.23828 5.1801 2.34364 4.92574 2.53117 4.73821C2.71871 4.55067 2.97306 4.44531 3.23828 4.44531H13.2383M6.73828 14.9453L4.23828 12.4453L6.73828 9.94531",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2383 9.44531V11.4453C15.2383 11.7105 15.1329 11.9649 14.9454 12.1524C14.7579 12.34 14.5035 12.4453 14.2383 12.4453H4.23828",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26411_8792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1.73828 1.44531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeagueSyncP);
export default __webpack_public_path__ + "static/media/league-sync-p.fe63485194bff391bd430177015825b6.svg";
export { ForwardRef as ReactComponent };